import { MagnifyingGlass } from "../icons/MagnifyingGlass";

export const ButtonSearch = (props) => {
  return (
    <button
      type="button"
      onClick={props.onClick}
      className={`${props.disabled ? "bg-[#525252]" : "bg-[#262626]"} px-8 ${
        props.disabled ? "" : "hover:bg-[#101010]"
      } ${props.data}`}
      disabled={props.disabled}
    >
      <span className="flex justify-center items-center w-full tablet:space-x-0 space-x-2">
        <span className="tablet:hidden block">
          <MagnifyingGlass fill="white" />
        </span>
        <span className="text-white font-roboto whitespace-nowrap">
          Valorar gratis
        </span>
      </span>
    </button>
  );
};

export default ButtonSearch;
